export const ENTER_KEY = 'Enter';
export const ESCAPE_KEY = 'Escape';
